module.exports = __webpack_public_path__ + "static/media/BASED.58a99516.svg";